import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useAuctionHouseSearchFilteringExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.AuctionHouseSearchFiltering,
        AmplitudeVariants.AuctionHouseSearchFiltering.Treatment
    );
